import React, { useState } from 'react';
import * as cls from './list-toggle.module.css';
import { Typography } from '../../components/typography/typography';
import { IMG_PATH } from '../../../constants';

const Arrow = () => {
  return (
    <svg
      width="16"
      height="8"
      viewBox="0 0 24 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0001 13.3751C11.8605 13.3752 11.7223 13.3478 11.5934 13.2944C11.4645 13.2409 11.3474 13.1626 11.2489 13.0638L0.623879 2.43875C0.208707 2.02358 0.208707 1.35129 0.623879 0.936379C1.03905 0.521473 1.71135 0.521207 2.12625 0.936379L12.0001 10.8102L21.8739 0.936379C22.2891 0.521207 22.9613 0.521207 23.3763 0.936379C23.7912 1.35155 23.7914 2.02385 23.3763 2.43875L12.7513 13.0638C12.6527 13.1626 12.5356 13.2409 12.4067 13.2944C12.2778 13.3478 12.1396 13.3752 12.0001 13.3751Z"
        fill="#999999"
      />
    </svg>
  );
};

export const ListToggle = ({
  animatedItems,
  classNameActive = cls.active,
  classNameAnimated = '',
  classNameHidden = '',
  iconCheck,
  items,
}) => {
  const [active, setActive] = useState(0);

  return (
    <>
      {items.map((item, index) => (
        <div
          className={`${cls.item} ${animatedItems.has(index) ? classNameAnimated : classNameHidden} ${active === index ? classNameActive : ''}`}
          key={index}
        >
          <button onClick={() => setActive(index)}>
            <span className={cls.itemLeft}>
              {item.icon ? (
                <img alt="" src={`${IMG_PATH}/home/${item.icon}`} />
              ) : iconCheck ? (
                <img
                  alt=""
                  className={cls.itemLeftCheck}
                  src={`${IMG_PATH}/ico-check.svg`}
                />
              ) : (
                <span className={cls.itemNumber}>{index + 1}</span>
              )}
              <Typography>
                <strong>{item.title}</strong>
              </Typography>
            </span>
            <Arrow />
          </button>
          <div className={cls.itemHidden}>{item.text}</div>
        </div>
      ))}
    </>
  );
};
